import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

export const screenReaderOnly = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

const styles = StyleSheet.create({
  container: {
    height: spacing.$0_5,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: spacing.$0_5,
  },
});
